<div class="meal-content" *ngIf="mealList.length > 0">
    <div class="meal-item">
        <label *ngFor="let meal of mealList; let i= index" [ngClass]="{ 'attention': attentionFlgList[i] }" class="lbl">{{ meal }}</label>
    </div>
</div>  